import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  model,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import type { ExportListItem } from '@api-response-types/export-list-item.response';
import { ExportStatus } from '@api-types/enums/export-status.enum';
import { DateUtilsService } from '@core/utils/date-utils.service';
import { FormInputCheckboxComponent, PmIconComponent } from '@libs/ui';
import { LucideCircleX, LucideLoaderCircle } from '@lucide/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pm-export-downloads-list',
  templateUrl: './export-downloads-list.component.html',
  imports: [
    TranslateModule,
    FormsModule,
    FormInputCheckboxComponent,
    PmIconComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportDownloadsListComponent {
  protected readonly dateUtilsService = inject(DateUtilsService);

  exports = input.required<ExportListItem[]>();
  selectedExportId = model<string | undefined>();

  protected readonly ExportStatus = ExportStatus;
  protected readonly loaderIcon = LucideLoaderCircle;
  protected readonly errorIcon = LucideCircleX;

  protected toggle(exportId: string): void {
    this.selectedExportId.set(
      this.selectedExportId() === exportId ? undefined : exportId,
    );
  }
}
